// extracted by mini-css-extract-plugin
export default {"smsform":"smsform_smsform__1Vtnj","smsform__box":"smsform_smsform__box__-yh+g"};